import { render, staticRenderFns } from "./DashboardHero.vue?vue&type=template&id=0dbcee86&scoped=true&"
import script from "./DashboardHero.vue?vue&type=script&lang=js&"
export * from "./DashboardHero.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHero.vue?vue&type=style&index=0&id=0dbcee86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbcee86",
  null
  
)

export default component.exports